import { EntityStatusOptions } from '../entityStatus';
import { CategoryListing } from './category';
import {  FileSummary } from './file';

export class CategoryFile {
    categoryId: number;
    fileId: number;
    categoryFilePrimary: boolean;
    fileName: string;
    category: CategoryListing;
    file: FileSummary;
    status: EntityStatusOptions;
    constructor(){
      this.categoryId = 0;
      this.fileId = 0;
      this.categoryFilePrimary = false;
      this.fileName = '';
      this.category = null;
      this.file = null;
      this.status = EntityStatusOptions.Active;
    }
}
